import * as React from 'react';
import BootstrapTable from "react-bootstrap-table-next";
import { ButtonGroup, Button, OverlayTrigger, Tooltip, } from "react-bootstrap";
import PDFTextract from "./pdf-textract";
import "./textractMapping.scss";
import { MapDataSearchDropdownList } from "../../Common/Components/MapDataSearchDropdownList";
import { resolve, reject } from "q";
import { Register as registersevice } from "../../Common/Services/Register";
import { ToastContainer, toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import ScrollContainer from 'react-indiana-drag-scroll';
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { confirmAlert } from "react-confirm-alert";
import { Utils } from '../../Common/Utilis';


export class TextractMapping extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            // fileSelect: "data:application/pdf;base64,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",
            fileSelect: this.props.selectedExtractFile[0].fileCode,
            fileName: this.props.selectedExtractFile[0].fileName,
            defaultName: "",
            disableArea: false,
            headerItemList: [],
            itemList: [],
            tableItemList:  props?.tableItemList=== undefined || props?.tableItemList=== null ? [] : props?.tableItemList,
            mapData: [],
            LinemapData: [],
            currentZoom: 1.0,
            // itemList: [
            //     { id : 1, name: "Invoice Date", eventKey: "invoiceDate", value: "05/26/2021", status: "Mapped" },
            //     { id : 2, name: "Invoice Number", eventKey: "invoiceNumber", value: "05/26/2021", status: "Mapped" },
            //     { id : 3, name: "Ship Date", eventKey: "shipDate", value: "05/26/2021", status: "" },
            //     { id : 4, name: "Date Due", eventKey: "dateDue", value: "05/26/2021", status: "" },
            //     { id : 5, name: "Login Token", eventKey: "loginToken", value: "05/26/2021", status: "" },
            //     { id : 6, name: "Please Pay From Invoice", eventKey: "payFromInvoice", value: "", status: "" },
            // ],
            // mapData: [
            //     { 'id': 1, name: 'Invoice Number', mappedField: '', dataPreview: '', isDisabled: false, isHighlight: false },
            //     { 'id': 2, name: 'Invoice Date', mappedField: '', dataPreview: '', isDisabled: false, isHighlight: false },
            //     { 'id': 3, name: 'Due Date', mappedField: '', dataPreview: '', isDisabled: false, isHighlight: false },
            // ]

            canvasElement: [
                { id: 1, width: "100", height: "20", xPos: "20", yPos: "30", relation: "Invoice Date", value: "05/26/2021" },
                { id: 2, width: "100", height: "20", xPos: "20", yPos: "60", relation: "Invoice Number", value: "06/26/2021" },
            ],
            canvaslist: [],
            linecanvaslist: [],
            mappedFiled: '',
            ismapped: false,
            isLinemapped: false,
            isSinglemapped: false,
            canvasSinglelist: [],
            canvasWidth: 0,
            canvasHeight: 0,
            documentLoaded: false,
            isChange: false,
            addChatIconStyle : '',
        };
    }

    componentDidMount() {
        //This code is for hide the ChatIcon
        const $style = document.createElement("style");
        $style.innerHTML = `#fc_frame, #fc_frame.fc-widget-normal { z-index: 1000 !important}`;
        this.setState({addChatIconStyle : document.head.appendChild($style)})
       
        //this.bindPdfTextRactData();
        // if(this.state.documentLoaded){
        //     
        //     setTimeout(() => {
        //         let refCanvasElement: any = document.getElementById('pdfDocument');
        //         let width:any = refCanvasElement.childNodes[0].childNodes[0].childNodes[0].childNodes[1].childNodes[0].clientWidth;
        //         let height:any = refCanvasElement.childNodes[0].childNodes[0].childNodes[0].childNodes[1].childNodes[0].clientHeight;
        //         this.setState({ canvasWidth: width, canvasHeight: height });
        //         this.bindPdfTextRactData();
        //       }, 2000);
        // }        
    }
    componentWillUnmount() {
        if(this.state.addChatIconStyle !== '') {
            document.head.removeChild(this.state.addChatIconStyle);
        }
     }

    bindPdfTextRactData = () => {


        let headerItemList: any = [];
        let tableItemList: any = [];
        let pdfList: any = {};
        pdfList = registersevice.bindPdfTextRactData(this.props.PdfExtractList);
        headerItemList = pdfList.headerItemList;
        if (this.props?.tableItemList.length > 0) {
            tableItemList = Object.assign([], JSON.parse(JSON.stringify(this.state.tableItemList)));
        } else {
            tableItemList = pdfList.tableItemList;
        }
        console.log(this.props.PdfExtractList);

        let canvasStyle = {
            top: 0 + "px",
            left: 0 + "px",
        }
        let canvaslist: any[] = [];
        let linecanvaslist: any[] = [];

        let headerData = this.props.PdfExtractList[0].invoiceJsonDetails;
        
        let distinctPages: any = headerData.map(headerData => headerData.pageNo)
        .filter((value, index, self) => self.indexOf(value) === index);

        let widthArr: any = [];
        for(let i = 0; i < distinctPages.length; i++) {
            for(let j = 0; j < headerData.length; j++) {
                if (distinctPages[i] === headerData[j].pageNo) {
                    widthArr.push({pageNo: distinctPages[i], pageHeight: headerData[j].pageHeight, pageWidth: headerData[j].pageWidth});
                    break;
                }
            }
        }

        let splitHeader = this.props.PdfExtractList[0].invoiceSpiltheader;
        
        let distinctPages1: any = splitHeader.map(splitHeader => splitHeader.pageno)
        .filter((value, index, self) => self.indexOf(value) === index);

        for(let i = 0; i < distinctPages1.length; i++) {
            let isPageExist = widthArr.findIndex((x) => x.pageNo === distinctPages1[i]);
            if(isPageExist === -1) {
                for(let j = 0; j < splitHeader.length; j++) {
                    if (distinctPages1[i] === splitHeader[j].pageno) {
                        widthArr.push({pageNo: distinctPages1[i], pageHeight: splitHeader[j].pageHeight, pageWidth: splitHeader[j].pageWidth});
                        break;
                    }
                }
            }
        }
        widthArr = widthArr.sort((a,b) => a.pageNo - b.pageNo);
        let heightFactor = this.state.canvasHeight / widthArr[0].pageHeight;
        let widthFactor = this.state.canvasWidth / widthArr[0].pageWidth;
        
        let heightDiff = 0;
        widthArr.forEach((element, index) => {
            element.pageDiff = heightDiff + (index * 64);
            heightDiff = heightDiff + (element.pageHeight * heightFactor);
        });

        this.props.PdfExtractList[0].invoiceJsonDetails.forEach((file: any, i: any) => {
            let width = (file.colNamGeometry.boundingBox.width * file.pageWidth * widthFactor) + 8;
            let index = widthArr.findIndex((x) => x.pageNo === file.pageNo);
            let top = (file.colNamGeometry.boundingBox.top * (file.pageHeight) * heightFactor) + ((widthArr[index].pageDiff)) - 4;
            let height = (file.colNamGeometry.boundingBox.height * (file.pageHeight) * heightFactor) +  6;
            let left = (file.colNamGeometry.boundingBox.left * file.pageWidth * widthFactor) - 4;
            let colName = file.coloumnName;
            canvasStyle = {
                top: top + "px",
                left: left + "px",
            }

            canvaslist.push(
                <canvas id={colName} width={width} height={height} style={canvasStyle}
                    onClick={() => this.bindColValue(colName, "Header")}
                ></canvas>
            );
        });


        this.props.PdfExtractList[0].invoiceSpiltheader.forEach((file: any, i: any) => {
            let width = (file.colNamGeometry.boundingBox.width * file.pageWidth * widthFactor) + 8;
            let index = widthArr.findIndex((x) => x.pageNo === file.pageno);
            let top = (file.colNamGeometry.boundingBox.top * (file.pageHeight) * heightFactor) + ((widthArr[index].pageDiff)) - 4;
            let height = (file.colNamGeometry.boundingBox.height * (file.pageHeight) * heightFactor) +  6;
            let left = (file.colNamGeometry.boundingBox.left * file.pageWidth * widthFactor) - 4;
            let colName = file.coloumnName;
            canvasStyle = {
                top: top + "px",
                left: left + "px",
            }

            linecanvaslist.push(
                <canvas id={colName} width={width} height={height} style={canvasStyle}
                    onClick={() => this.bindColValue(colName, "LineItem")}
                ></canvas>
            );
        });
        headerItemList.map((item) => {
            item.status = "";
        })
        this.props.mapData.forEach((e) => {
            headerItemList.map((item) => {
                if (item.name.toString().toLowerCase() === e.mappedField.toLowerCase()) {
                    item.status = "mapped";
                };
            })
        })
        if (this.props?.tableItemList.length === 0) {
            tableItemList.map((item) => {
                item.status = "";
            })

            this.props.LinemapData.forEach((e) => {
                tableItemList.map((item) => {
                    if (item.name.toString().toLowerCase() === e.mappedField.toLowerCase()) {
                        item.status = "mapped";
                    };
                })
            })
        }
        this.setState({ canvaslist: [], linecanvaslist: [], headerItemList: [], tableItemList: [], mapData: [], LinemapData: [] }, () => {
            this.setState({
                canvaslist: canvaslist, linecanvaslist: linecanvaslist,
                headerItemList, tableItemList, mapData: this.props.mapData, LinemapData: this.props.LinemapData
            }, () => {
                this.disableDropdownOptions();
            });
        });

    }

    disableDropdownOptions = () => {
        let selectedDistinctListItem:any = [];
        let arr = this.state.tableItemList.filter((item) => item.mappedTo !== "");
        selectedDistinctListItem = arr.map(data => data.dbName)
        .filter((value, index, self) => self.indexOf(value) === index);

        this.state.headerItemList.map((item) => {
            item.disabled = false;
        })

        this.state.tableItemList.map((item) => {
            item.disabled = false;
        })

        selectedDistinctListItem.forEach((selected) => {
            this.state.headerItemList.forEach((item) => {
                if(item.dbName === selected) {
                    item.disabled = true;
                }
            })
        });

        let selectedDistinctHeader:any = [];
        let arr1 = this.state.mapData.filter((item) => item.dbName !== "");
        selectedDistinctHeader = arr1.map(data => data.dbName)
        .filter((value, index, self) => self.indexOf(value) === index);

        selectedDistinctHeader.forEach((selected) => {
            this.state.tableItemList.forEach((item) => {
                if(item.dbName === selected) {
                    item.disabled = true;
                }
            })
        });
    }

    updateHighlightOnZoom = () => {
        let headerItemList: any = [];
        let tableItemList: any = [];
        let pdfList: any = {};
        pdfList = registersevice.bindPdfTextRactData(this.props.PdfExtractList);
        headerItemList = pdfList.headerItemList;
        tableItemList = pdfList.tableItemList;

        let canvasStyle = {
            top: 0 + "px",
            left: 0 + "px",
        }
        let canvaslist: any[] = [];
        let linecanvaslist: any[] = [];

        let headerData = this.props.PdfExtractList[0].invoiceJsonDetails;
        
        let distinctPages: any = headerData.map(headerData => headerData.pageNo)
        .filter((value, index, self) => self.indexOf(value) === index);

        let widthArr: any = [];
        for(let i = 0; i < distinctPages.length; i++) {
            for(let j = 0; j < headerData.length; j++) {
                if (distinctPages[i] === headerData[j].pageNo) {
                    widthArr.push({pageNo: distinctPages[i], pageHeight: headerData[j].pageHeight, pageWidth: headerData[j].pageWidth});
                    break;
                }
            }
        }

        let splitHeader = this.props.PdfExtractList[0].invoiceSpiltheader;
        
        let distinctPages1: any = splitHeader.map(splitHeader => splitHeader.pageNo)
        .filter((value, index, self) => self.indexOf(value) === index);

        for(let i = 0; i < distinctPages1.length; i++) {
            let isPageExist = widthArr.findIndex((x) => x.pageNo === distinctPages1[i]);
            if(isPageExist === -1) {
                for(let j = 0; j < splitHeader.length; j++) {
                    if (distinctPages1[i] === splitHeader[j].pageNo) {
                        widthArr.push({pageNo: distinctPages1[i], pageHeight: splitHeader[j].pageHeight, pageWidth: splitHeader[j].pageWidth});
                        break;
                    }
                }
            }
        }
        widthArr = widthArr.sort((a,b) => a.pageNo - b.pageNo);
        let heightFactor = this.state.canvasHeight / widthArr[0].pageHeight;
        let widthFactor = this.state.canvasWidth / widthArr[0].pageWidth;
        
        let heightDiff = 0;
        widthArr.forEach((element, index) => {
            element.pageDiff = heightDiff + (index * 64 / this.state.currentZoom);
            heightDiff = heightDiff + (element.pageHeight * heightFactor);
        });

        this.props.PdfExtractList[0].invoiceJsonDetails.forEach((file: any, i: any) => {
            let width = (file.colNamGeometry.boundingBox.width * file.pageWidth * widthFactor) + 8;
            let index = widthArr.findIndex((x) => x.pageNo === file.pageNo);
            let top = (file.colNamGeometry.boundingBox.top * (file.pageHeight) * heightFactor) + ((widthArr[index].pageDiff)) - 4;
            let height = (file.colNamGeometry.boundingBox.height * (file.pageHeight) * heightFactor) +  6;
            let left = (file.colNamGeometry.boundingBox.left * file.pageWidth * widthFactor) - 4;
            let colName = file.coloumnName;
            canvasStyle = {
                top: top + "px",
                left: left + "px",
            }

            canvaslist.push(
                <canvas id={colName} width={width} height={height} style={canvasStyle}
                    onClick={() => this.bindColValue(colName, "Header")}
                ></canvas>
            );
        });


        this.props.PdfExtractList[0].invoiceSpiltheader.forEach((file: any, i: any) => {
            let width = (file.colNamGeometry.boundingBox.width * file.pageWidth * widthFactor) + 8;
            let index = widthArr.findIndex((x) => x.pageNo === file.pageno);
            let top = (file.colNamGeometry.boundingBox.top * (file.pageHeight) * heightFactor) + ((widthArr[index].pageDiff)) - 4;
            let height = (file.colNamGeometry.boundingBox.height * (file.pageHeight) * heightFactor) +  6;
            let left = (file.colNamGeometry.boundingBox.left * file.pageWidth * widthFactor) - 4;
            let colName = file.coloumnName;
            canvasStyle = {
                top: top + "px",
                left: left + "px",
            }

            linecanvaslist.push(
                <canvas id={colName} width={width} height={height} style={canvasStyle}
                    onClick={() => this.bindColValue(colName, "LineItem")}
                ></canvas>
            );
        });
        this.setState({ canvaslist: [], linecanvaslist: [] }, () => {
            this.setState({
                canvaslist: canvaslist, linecanvaslist: linecanvaslist,
            });
        });
    }

    getPixelWidth(value) {
        // let Left = boundingBoxWidth / Totaldocumentwidth

        let valInPixel = this.state.canvasWidth * value;
        return valInPixel;
    }
    getPixelHeight(value) {
        // let Left = boundingBoxWidth / Totaldocumentwidth

        let valInPixel = this.state.canvasHeight * value;
        return valInPixel;
    }

    getPdfMasterMapping() {
        let request: any = {};
        request.Vid = this.props.selectedExtractFile[0].vendorID;
        request.TenantID = this.props.selectedExtractFile[0].tenantID;
        registersevice.InvoiceMappingMasterDetails(request)
            .then(async (result: any | null) => {
                if (result !== null) {

                    let mapData: any = [];
                    let LinemapData: any = [];


                    result.forEach((element, index) => {
                        let item: any = {};
                        item.id = element.id;
                        item.name = element.colName;
                        item.isDisabled = false;
                        item.isHighlight = false;
                        let mappedcolName = element.mappedCol;

                        if (element.type.toString().toLowerCase() === "header") {

                            let colValueList = this.props.PdfExtractList[0].invoiceJsonDetails.filter(x => x.coloumnName.toString().toLowerCase() === mappedcolName.toString().toLowerCase())
                            let colValue = "";
                            if (colValueList.length > 0) {
                                colValue = colValueList[0].coloumnValues;
                            }

                            item.mappedField = mappedcolName;
                            item.dataPreview = colValue;
                            mapData.push(item);
                        }
                        else {

                            let colValueList = this.props.PdfExtractList[0].invoiceSpiltDetails.filter(x => x.coloumnName.toString().toLowerCase() === mappedcolName.toString().toLowerCase())
                            let colValue = "";
                            if (colValueList.length > 0) {
                                colValue = colValueList[0].coloumnValues;
                            }
                            item.mappedField = mappedcolName;
                            item.dataPreview = colValue;
                            LinemapData.push(item);
                        }
                    });

                    this.setState({ mapData, LinemapData });
                }
                resolve();
            })
            .catch((error) => {
                this.setState({ isSpinner: false })
                reject();
            });
    }


    tableSelectedItem = (control: any, event: any) => {
        // debugger;
        let type = control === 0 ? "Description" : "Amount";
        this.setState({ isSinglemapped: false, canvasSinglelist: [], isChange: true });
        let LinemapData = Object.assign([], JSON.parse(JSON.stringify(this.state.LinemapData)));
        let mapData = Object.assign([], JSON.parse(JSON.stringify(this.state.mapData)));
        LinemapData[control].mappedField = event.name;
        LinemapData[control].dataPreview = event.value;

        mapData.forEach(element => {
            element.isHighlight = false;
            element.isDisabled = false;
        });

        LinemapData.forEach(element1 => {
            element1.isHighlight = false;
            element1.isDisabled = false;
        });
        // this.state.tableItemList.map((item) => {
        //     item.status = "";
        // })
        LinemapData.forEach((e) => {
            this.state.tableItemList.map((item) => {
                if (item.name === e.mappedField) {
                    item.status = "mapped";
                };
            })
        })
        if (this.state.tableItemList.filter((item) => item.id === event?.id).length > 0) {
            const index = this.state.tableItemList.findIndex((x) => x.id === event?.id);
            this.state.tableItemList.map((item) => {
                if (item.mappedTo === type) {
                    item.status = "";
                    item.mappedTo = "";
                }
            });
            this.state.tableItemList[index].status = "mapped";
            this.state.tableItemList[index].mappedTo = type;
        } else {
            this.state.tableItemList.map((item) => {
                if (item.mappedTo === type) {
                    item.status = "";
                    item.mappedTo = "";
                }
            });
        }
        this.setState({LinemapData:[],mapData:[] },()=>{
            this.setState({ mapData, LinemapData, disableArea: false, ismapped: false, isLinemapped: false }, () => {
                this.disableDropdownOptions();
            });
        });
    }

    tableSelectedCheckbox = (control: any, rows: any) => {
        this.setState({ isSinglemapped: false, canvasSinglelist: [], isChange: true });
        let LinemapData = Object.assign([], JSON.parse(JSON.stringify(this.state.LinemapData)));
        let mapData = Object.assign([], JSON.parse(JSON.stringify(this.state.mapData)));
        let type = control === 0 ? "Description" : "Amount";
        if (rows.length > 0) {
            LinemapData[control].mappedField = rows[0].name;
            LinemapData[control].dataPreview = rows[0].value;
        } else {
            LinemapData[control].mappedField = "";
            LinemapData[control].dataPreview = "";
        }

        mapData.forEach(element => {
            element.isHighlight = false;
            element.isDisabled = false;
        });

        LinemapData.forEach(element1 => {
            element1.isHighlight = false;
            element1.isDisabled = false;
        });

        this.state.tableItemList.map((item) => {
            if (rows.filter((x) => x.id === item.id).length > 0) {
                const index = rows.findIndex((x) => x.id === item.id);
                item.status = "mapped";
                item.mappedTo = rows[index].mappedTo;
            } else {
                if (type === item.mappedTo) {
                    item.status = "";
                    item.mappedTo = "";
                }
            }
        })

       this.setState({LinemapData:[],mapData:[] },()=>{
        this.setState({ mapData, LinemapData, disableArea: false, ismapped: false, isLinemapped: false }, () => {
            this.disableDropdownOptions();
        });
       });
    }

    handleSelectedItem = (control: any, event: any) => {
        
        this.setState({ isSinglemapped: false, canvasSinglelist: [], isChange: true });
        let mapData = Object.assign([], JSON.parse(JSON.stringify(this.state.mapData)));
        let LinemapData = Object.assign([], JSON.parse(JSON.stringify(this.state.LinemapData)));
        mapData[control].mappedField = event.name;
        mapData[control].dataPreview = event.value;
        mapData[control].dbName = event.dbName;
        mapData.forEach(element => {
            element.isHighlight = false;
            element.isDisabled = false;
        });

        LinemapData.forEach(element1 => {
            element1.isHighlight = false;
            element1.isDisabled = false;
        });

        this.state.headerItemList.map((item) => {
            item.status = "";
        })

        mapData.forEach((e) => {
            this.state.headerItemList.map((item) => {
                if (item.name === e.mappedField) {
                    item.status = "mapped";
                };
            })
        })
        this.setState({mapData:[], LinemapData:[]},()=>{
            this.setState({ mapData, LinemapData, disableArea: false, ismapped: false, isLinemapped: false }, () => {
                this.disableDropdownOptions();
            });
        });
        
    }

    handledisable = (rowIndex, mappedFiled, type) => {
        let mapData = Object.assign([], JSON.parse(JSON.stringify(this.state.mapData)));
        let LinemapData = Object.assign([], JSON.parse(JSON.stringify(this.state.LinemapData)));
        // mapData.isDisabled = true;
        if (type === "Header") {
            for (let i = 0; i < mapData.length; i++) {
                mapData[i].isDisabled = true;
                mapData[rowIndex].isDisabled = false;
                mapData[rowIndex].isHighlight = true;
            }

            for (let i = 0; i < LinemapData.length; i++) {
                LinemapData[i].isDisabled = true;
            }

            this.setState({
                isChange: true,
                mapData: mapData, LinemapData: LinemapData, disableArea: true,
                mappedFiled: mappedFiled, ismapped: true, isLinemapped: false
            });
        }
        else {
            for (let i = 0; i < LinemapData.length; i++) {
                LinemapData[i].isDisabled = true;
                LinemapData[rowIndex].isDisabled = false;
                LinemapData[rowIndex].isHighlight = true;
            }

            for (let i = 0; i < mapData.length; i++) {
                mapData[i].isDisabled = true;
            }

            this.setState({
                isChange: true,
                mapData: mapData, LinemapData: LinemapData, disableArea: true,
                mappedFiled: mappedFiled, ismapped: false, isLinemapped: true
            });
        }


    }

    cancelDisable = () => {
        let mapData = Object.assign([], JSON.parse(JSON.stringify(this.state.mapData)));
        let LinemapData = Object.assign([], JSON.parse(JSON.stringify(this.state.LinemapData)));
        mapData.forEach(element => {
            element.isHighlight = false;
            element.isDisabled = false;
        });

        LinemapData.forEach(element1 => {
            element1.isHighlight = false;
            element1.isDisabled = false;
        });
        this.setState({mapData:[], LinemapData:[]},()=>{
            this.setState({ mapData, LinemapData, disableArea: false, ismapped: false, isLinemapped: false });
        });
    }

    handleMouseOver = (controlID, name, mappedname) => {
        let canvasSinglelist: any = [];
        //if (this.state.ismapped === false && this.state.isLinemapped === false) {
        if (controlID === 1) {
            canvasSinglelist.push(this.state.canvaslist.filter(x => x.props.id.toString().toLowerCase() === mappedname.toLowerCase()));
            this.setState({ mappedFiled: name, isSinglemapped: true, canvasSinglelist: canvasSinglelist });
        }
        else {
            canvasSinglelist.push(this.state.linecanvaslist.filter(x => x.props.id.toString().toLowerCase() === mappedname.toLowerCase()));
            this.setState({ mappedFiled: name, isSinglemapped: true, canvasSinglelist: canvasSinglelist });
        }
        // }
    }
    handleMouseLeave = (controlID, name, mappedname) => {
        this.setState({ isSinglemapped: false, canvasSinglelist: [] });
    }

    bindColValue = (colname, type) => {
        let mapData = Object.assign([], JSON.parse(JSON.stringify(this.state.mapData)));
        let LinemapData = Object.assign([], JSON.parse(JSON.stringify(this.state.LinemapData)));
        if (type === "Header") {
            let selectedCol = this.state.headerItemList.filter(x => x.name.toString().toLowerCase() === colname.toLowerCase());
            let isAlreadySelected = this.state.tableItemList.filter(x => x.dbName.toString().toLowerCase() === selectedCol[0]?.dbName.toLowerCase() && x.mappedTo !== "");
            if (isAlreadySelected.length > 0) {
                Utils.toastError("This field is already selected in Line Items. Please select a different field.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "textractMap",
                });
                return;
            } else {
                mapData.forEach(element => {
                    if (element.name.toString().toLowerCase() === this.state.mappedFiled.toLowerCase()) {
                        element.mappedField = colname;
                        element.dataPreview = selectedCol[0].value;
                        element.dbName = selectedCol[0]?.dbName;
                        element.isHighlight = false;
                    }
                    element.isDisabled = false;
                });

                LinemapData.forEach(element1 => {
                    element1.isDisabled = false;
                });
            }
        }
        else {
            let isAlreadySelected = this.state.tableItemList.filter(x => x.name.toString().toLowerCase() === colname.toLowerCase() && x.mappedTo !== "");
            let selectedCol = this.state.tableItemList.filter(x => x.name.toString().toLowerCase() === colname.toLowerCase());
            let isAlreadySelectedInHeader = mapData.filter(x => x.dbName.toString().toLowerCase() === selectedCol[0].dbName.toLowerCase());
            if (isAlreadySelected.length > 0 || isAlreadySelectedInHeader.length > 0) {
                Utils.toastError("This field is already selected in Header or Line Items. Please select a different field.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "textractMap",
                });
                return;
            } else {
                LinemapData.forEach(element => {
                    if (element.name === this.state.mappedFiled) {
                        element.mappedField = colname;
                        element.dataPreview = selectedCol[0].value;
                        element.isHighlight = false;
                    }
                    element.isDisabled = false;
                });
                mapData.forEach(element1 => {
                    element1.isDisabled = false;
                });
                this.state.tableItemList.map((item) => {
                    if (item.name === colname) {
                        item.status = "mapped";
                        item.mappedTo = this.state.mappedFiled;
                    }
                })
            }
        }
        this.setState({ mapData: [], LinemapData: [] }, () => {
            this.setState({ mapData: mapData, LinemapData: LinemapData, disableArea: false, ismapped: false, isLinemapped: false, isSinglemapped: false }, () => {
                this.disableDropdownOptions();
            });
        });

    }

    saveInvoiceMapping = () => {
        setTimeout(()=> {
            let saveRequest = registersevice.saveInvoiceMapping(this.props.selectedExtractFile, this.state.mapData, this.state.LinemapData, this.state.tableItemList)
            this.SaveInvoicePdfExtraction(saveRequest);
        }, 250)
    }

    pageClose = () => {
        this.setState({ isChange: false }, () => {
            this.props.closeTextract();
        })
    }


    SaveInvoicePdfExtraction(request) {
        
        this.setState({ isSpinner: true })
        registersevice.SaveInvoicePdfExtraction(request)
            .then(async (result: any | null) => {
                this.setState({ isSpinner: false })
                if (result !== null) {
                    if (result.saveStatus === "Success") {

                        toast.success("Mapping saved successfully.", {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            containerId: "InvoiceTextract",
                        });
                        this.props.updateParentMapping(this.state.mapData, this.state.LinemapData, this.state.tableItemList);
                        this.mapLineItem();


                    }
                    else {
                        Utils.toastError(result.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            containerId: "InvoiceTextract",
                        });
                    }
                }
                resolve();
            })
            .catch((error) => {
                this.setState({ isSpinner: false })
                reject();
            });
    }
    mapLineItem = () => {
        let splitItem: any = [];
        splitItem = registersevice.mapLineItem(this.state.LinemapData, this.props.PdfExtractList, this.state.tableItemList);
        console.log(splitItem);
        console.log(this.state.mapData);
        this.props.invoiceMapDate(splitItem, this.state.mapData, true)
    }



    closeTextract = () => {
        if (this.state.isChange) {
            confirmAlert({
                title: "Unsaved confirmation",
                message:
                    "You have unsaved changes on this page. Do you want to leave this page and discard your changes?",
                buttons: [
                    {
                        label: "Yes",
                        onClick: () => this.pageClose(),
                    },
                    {
                        label: "No",
                        onClick: () => reject(),
                    },
                ],
                closeOnEscape: false,
                closeOnClickOutside: false,
            });
        } else {
            this.props.closeTextract();
        }

    }

    handleZoom = (event) => {
        let currZoom = this.state.currentZoom;
        let updateZoom;
        if (event === "zoomIn") {
            updateZoom = currZoom * 1.5;
        } else {
            updateZoom = currZoom / 1.5;
        }
        this.setState({ currentZoom: updateZoom }, () => {
            this.updateHighlightOnZoom();
        });
        // setTimeout(() => {
        //     let refCanvasElement: any = document.getElementById('pdfDocument');
        //     let width:any = refCanvasElement.childNodes[0].childNodes[0].childNodes[0].childNodes[1].childNodes[0].clientWidth;
        //     let height:any = refCanvasElement.childNodes[0].childNodes[0].childNodes[0].childNodes[1].childNodes[0].clientHeight;
        //     this.setState({ canvasWidth: width, canvasHeight: height });
        //   }, 100);        
    }
    handleLoadSuccess = (loaded) => {
        
        //this.setState({ documentLoaded: loaded });
        if (loaded) {
            setTimeout(() => {
                let refCanvasElement: any = document.getElementById('pdfDocument');
                let width: any = refCanvasElement.childNodes[0].childNodes[0].childNodes[0].childNodes[1].childNodes[0].clientWidth;
                let height: any = refCanvasElement.childNodes[0].childNodes[0].childNodes[0].childNodes[1].childNodes[0].clientHeight;
                this.setState({ canvasWidth: width, canvasHeight: height });
                this.bindPdfTextRactData();
            }, 1000);
        }

    }

    removeMapping = (rowIndex, mappedFiled, type) => {
        if (type === "Header") {
            this.setState({ isSinglemapped: false, canvasSinglelist: [], isChange: true });
            let mapData = Object.assign([], JSON.parse(JSON.stringify(this.state.mapData)));
            let LinemapData = Object.assign([], JSON.parse(JSON.stringify(this.state.LinemapData)));
            mapData[rowIndex].mappedField = "";
            mapData[rowIndex].dataPreview = "";
            mapData[rowIndex].dbName = "";
            mapData.forEach(element => {
                element.isHighlight = false;
                element.isDisabled = false;
            });

            LinemapData.forEach(element1 => {
                element1.isHighlight = false;
                element1.isDisabled = false;
            });

            this.state.headerItemList.map((item) => {
                item.status = "";
            })

            mapData.forEach((e) => {
                this.state.headerItemList.map((item) => {
                    if (item.name === e.mappedField) {
                        item.status = "mapped";
                    };
                })
            })
            this.setState({ mapData: [], LinemapData: [] }, () => {
                this.setState({ mapData, LinemapData, disableArea: false, ismapped: false, isLinemapped: false }, () => {
                    this.disableDropdownOptions();
                });
            });
        } else {
            let type = rowIndex === 0 ? "Description" : "Amount";
            this.setState({ isSinglemapped: false, canvasSinglelist: [], isChange: true });
            let LinemapData = Object.assign([], JSON.parse(JSON.stringify(this.state.LinemapData)));
            let mapData = Object.assign([], JSON.parse(JSON.stringify(this.state.mapData)));
            LinemapData[rowIndex].mappedField = "";
            LinemapData[rowIndex].dataPreview = "";

            mapData.forEach(element => {
                element.isHighlight = false;
                element.isDisabled = false;
            });

            LinemapData.forEach(element1 => {
                element1.isHighlight = false;
                element1.isDisabled = false;
            });

            this.state.tableItemList.map((item) => {
                if (item.mappedTo === type) {
                    item.status = "";
                    item.mappedTo = "";
                }
            });
            this.setState({ LinemapData: [], mapData: [] }, () => {
                this.setState({ mapData, LinemapData, disableArea: false, ismapped: false, isLinemapped: false }, () => {
                    this.disableDropdownOptions();
                });
            });
        }
    }

    render() {
        let canvasStyle = {
            top: this.props.yPos + "px",
            left: this.props.xPos + "px",
        }
        let canvasRootStyle = {
            width: this.state.canvasWidth + "px",
            height: this.state.canvasHeight + "px",
            transform: `scale(${this.state.currentZoom})`,
            transformOrigin: `${0}px ${0}px`
        }
        const rowClasses = (row, rowIndex) => {
            let classes: any = null;
            if (row.isDisabled === true) {
                classes = 'disabled';
            }
            if (row.mappedField === "") {
                classes = 'blank';
            }
            if (row.isDisabled === true && row.mappedField === "") {
                classes = 'blank disabled';
            }
            return classes;
        };

        const columns = [{
            dataField: 'name',
            text: 'Inn-Flow Field',
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                    <div className='d-flex'>
                        <div className='mr-auto inn-flow-feild'>{row.name}</div>
                        <div>
                            <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.2" d="M9.96975 9.96973L11.0303 11.0302L16.0605 5.99998L11.0303 0.969727L9.96975 2.03023L13.1895 5.24998H0V6.74998H13.1895L9.96975 9.96973Z" fill="white" />
                            </svg>
                        </div>
                    </div>
                )
            }
        }, {
            dataField: 'mappedField',
            text: 'Mapped Field',
            headerClasses: 'map-cell',
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                    <div className='map-dropdown'>
                        <MapDataSearchDropdownList
                            itemList={this.state.headerItemList}
                            handleSelectedItem={this.handleSelectedItem.bind(row, rowIndex)}
                            defaultText={"Search..."}
                            defaultName={row.mappedField}
                            controlID="1"   // Header
                            handleMouseOver={this.handleMouseOver.bind(row, 1, row.name)}
                            handleMouseLeave={this.handleMouseLeave.bind(row, 1, row.name)}
                            isMultiSelect={false}
                        ></MapDataSearchDropdownList>
                    </div>
                )
            }
        }, {
            dataField: 'dataPreview',
            text: 'Data Preview',
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                    <>
                        {row.isHighlight ? (
                            <div className='info-text d-flex'>
                                <EllipsisWithTooltip placement="bottom">
                                    Select field from the invoice on the left to map
                                </EllipsisWithTooltip>
                                <button type="button" className="btn wht-bg cross" onClick={this.cancelDisable}>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" fill="white" />
                                    </svg>
                                </button>
                            </div>
                        ) :
                            <div className='d-flex align-items-center'>
                                <div className='mr-auto data'>
                                    <EllipsisWithTooltip placement="bottom">
                                        {row.dataPreview}
                                    </EllipsisWithTooltip>
                                </div>
                                <div className='map-btn'>
                                    {row.mappedField !== "" &&
                                        <button type="button" className="btn map"
                                            onClick={(e: any) => this.removeMapping(rowIndex, row.name, "Header")}>
                                            Remove Mapping
                                        </button>
                                    }
                                    {row.mappedField === "" &&
                                        <OverlayTrigger
                                            placement="bottom"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={
                                                <Tooltip id={"map-data"}>
                                                    {
                                                        "Clicking here allows you to select a value from the PDF to map to this field."
                                                    }
                                                </Tooltip>
                                            }
                                        >
                                            <button type="button" className="btn map"
                                                onClick={(e: any) => this.handledisable(rowIndex, row.name, "Header")}>
                                                Map Data from PDF
                                            </button>
                                        </OverlayTrigger>
                                    }
                                </div>
                            </div>
                        }
                    </>
                )
            }
        }];


        const Linecolumns = [{
            dataField: 'name',
            text: 'Inn-Flow Field',
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                    <div className='d-flex'>
                        <div className='mr-auto inn-flow-feild'>{row.name}</div>
                        <div>
                            <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.2" d="M9.96975 9.96973L11.0303 11.0302L16.0605 5.99998L11.0303 0.969727L9.96975 2.03023L13.1895 5.24998H0V6.74998H13.1895L9.96975 9.96973Z" fill="white" />
                            </svg>
                        </div>
                    </div>
                )
            }
        }, {
            dataField: 'mappedField',
            text: 'Mapped Field',
            headerClasses: 'map-cell',
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                    <div className='map-dropdown'>
                        <MapDataSearchDropdownList
                            itemList={this.state.tableItemList}
                            handleSelectedItem={this.tableSelectedItem.bind(row, rowIndex)}
                            defaultText={"Search..."}
                            defaultName={row.mappedField}
                            controlID="2"    // Line Item
                            handleMouseOver={this.handleMouseOver.bind(row, 2, row.name)}
                            handleMouseLeave={this.handleMouseLeave.bind(row, 2, row.name)}
                            isMultiSelect={this.props.PdfExtractList[0]?.totalPages > 1 ? true : false}
                            tableSelectedCheckbox={this.tableSelectedCheckbox.bind(row, rowIndex)}
                            field={rowIndex === 0 ? "Description" : "Amount"}
                        ></MapDataSearchDropdownList>
                    </div>
                )
            }
        }, {
            dataField: 'dataPreview',
            text: 'Data Preview',
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                    <>
                        {row.isHighlight ? (
                            <div className='info-text d-flex'>
                                <EllipsisWithTooltip placement="top">
                                    Select field from the invoice on the left to map
                                </EllipsisWithTooltip>
                                <button type="button" className="btn wht-bg cross" onClick={this.cancelDisable}>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"/>
                                    </svg>
                                </button>
                            </div>
                        ) :
                            <div className='d-flex align-items-center'>
                                <div className='mr-auto data'>
                                    <EllipsisWithTooltip placement="top">
                                        {row.dataPreview}
                                    </EllipsisWithTooltip>
                                </div>

                                <div className='map-btn'>
                                    {row.mappedField !== "" &&
                                        <button type="button" className="btn map"
                                            onClick={(e: any) => this.removeMapping(rowIndex, row.name, "LineItem")}>
                                            Remove Mapping
                                        </button>
                                    }
                                    {row.mappedField === "" &&
                                        <OverlayTrigger
                                            placement="top"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={
                                                <Tooltip id={"map-data"}>
                                                    {
                                                        "Clicking here allows you to select a value from the PDF to map to this field."
                                                    }
                                                </Tooltip>
                                            }
                                        >
                                            <button type="button" className="btn map"
                                                onClick={(e: any) => this.handledisable(rowIndex, row.name, "LineItem")}>
                                                Map Data from PDF
                                            </button>
                                        </OverlayTrigger>
                                    }
                                </div>
                            </div>
                        }
                    </>
                )
            }
        }];

        let base64file: any = [];

        for (let i = 0; i < this.props.PdfExtractList[0]?.base64PdfList.length; i++) {
           let base64 = "data:application/pdf;base64," + this.props.PdfExtractList[0]?.base64PdfList[i].base64;
           base64file.push(base64);
        }

        return (
            <div className='textract-map pos-fixed'>
                {/* <ToastContainer
                    autoClose={3000}
                    containerId={"InvoiceTextract"}
                    enableMultiContainer
                /> */}

                <div className="header-panel d-flex justify-content-between align-items-center">
                    <div className="page-ttl">Extract Mapping</div>
                    <div className="action d-flex">
                        <button type="button" className="btn btn-primary" onClick={this.saveInvoiceMapping}>Save Changes</button>
                        <button type="button" className="btn wht-bg cross" onClick={this.closeTextract}>
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" fill="white" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div id="pdfDocument" className='d-flex'>
                    <ScrollContainer className='panel left'>
                        {this.state.fileSelect.length > 0 && (
                            <PDFTextract filePreview={base64file[0]} fileName={this.state.fileName}
                                pageno={this.props.selectedExtractFile[0].newpageno}
                              // pageno={1}
                                LoadSuccess={this.handleLoadSuccess.bind(this.state.documentLoaded)}
                                selectedZoom={this.state.currentZoom}
                            ></PDFTextract>
                        )}

                        {this.state.ismapped && (
                            <div className='canvas-element' style={canvasRootStyle}>
                                {this.state.canvaslist}

                            </div>
                        )}

                        {this.state.isLinemapped && (
                            <div className='canvas-element' style={canvasRootStyle}>
                                {this.state.linecanvaslist}

                            </div>
                        )}



                        {this.state.isSinglemapped && (
                            <div className='canvas-element active' style={canvasRootStyle}>
                                {this.state.canvasSinglelist}

                            </div>
                        )}
                        <div className="zoom-btn">
                            <ButtonGroup vertical>
                                <Button onClick={(e) => this.handleZoom("zoomIn")} disabled={this.state.currentZoom >= 3.375 ? true : false}><FontAwesomeIcon icon={faPlus} /></Button>
                                <Button onClick={(e) => this.handleZoom("zoomOut")} disabled={this.state.currentZoom <= 0.44 ? true : false}><FontAwesomeIcon icon={faMinus} /></Button>
                            </ButtonGroup>
                        </div>
                    </ScrollContainer>
                    <div className='panel right'>
                        {(this.state.LinemapData.length > 0 && this.state.mapData.length > 0) && (
                            <>
                                {(this.state.LinemapData.filter(x => x.mappedField === '').length > 0 || this.state.mapData.filter(x => x.mappedField === '').length > 0) ?
                                    <div className='badge orange'>
                                        <EllipsisWithTooltip placement="bottom">
                                            <div className='ellipsis'>We weren’t able to complete all of the data mapping needed for Extract. Map the highlighted data below.</div>
                                        </EllipsisWithTooltip>
                                    </div>
                                    :
                                    <div className='badge green ellipsis'>
                                        <EllipsisWithTooltip placement="bottom">
                                            <div className='ellipsis'>All mappings completed! Save changes to continue extracting text.</div>
                                        </EllipsisWithTooltip>
                                    </div>
                                }

                            </>
                        )}

                        <div className='section'>
                            <div className={this.state.disableArea ? 'sec-ttl disabled' : 'sec-ttl'}>Header</div>
                            <BootstrapTable keyField='id' data={this.state.mapData} columns={columns} rowClasses={rowClasses} headerClasses={this.state.disableArea ? "disabled" : ""} />
                        </div>
                        <div className='section'>
                            <div className={this.state.disableArea ? 'sec-ttl disabled' : 'sec-ttl'}>Line Items</div>
                            <BootstrapTable keyField='id' data={this.state.LinemapData} columns={Linecolumns} rowClasses={rowClasses} headerClasses={this.state.disableArea ? "disabled" : ""} />
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}